import setAgentLocalState from 'actions/agent_local_state/set_agent_local_state';

export default class ToggleTaskFormattingVisible {
  constructor(context) {
    this.context = context;
  }

  run() {
    const localState = this.context.stores.agentLocalState.get();
    localState.toggleIsTaskCommentFormattingOpen();
    setAgentLocalState(this.context, localState);
  }
}
